var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonLaddaner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.161,
    height: 26.161,
    viewBox: "0 0 26.161 26.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-minimalistic-svgrepo-com",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37814",
    "data-name": "Path 37814",
    d: "M14.229,21.011a.987.987,0,0,1-1.457,0L7.509,15.253a.987.987,0,0,1,1.457-1.332L12.514,17.8V3.237a.987.987,0,1,1,1.974,0V17.8l3.549-3.881a.987.987,0,1,1,1.457,1.332Z",
    transform: "translate(1.58)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37815",
    "data-name": "Path 37815",
    d: "M4.224,15.237a.987.987,0,0,0-1.974,0v.072A36.082,36.082,0,0,0,2.4,19.7,4.892,4.892,0,0,0,3.7,22.674a4.891,4.891,0,0,0,2.974,1.292,36.1,36.1,0,0,0,4.391.153H19.1a36.1,36.1,0,0,0,4.391-.153,4.892,4.892,0,0,0,2.974-1.292A4.891,4.891,0,0,0,27.758,19.7a36.1,36.1,0,0,0,.153-4.391v-.072a.987.987,0,1,0-1.974,0,35.372,35.372,0,0,1-.136,4.2,2.967,2.967,0,0,1-.732,1.841,2.967,2.967,0,0,1-1.841.732,35.372,35.372,0,0,1-4.2.136h-7.9a35.371,35.371,0,0,1-4.2-.136,2.967,2.967,0,0,1-1.841-.732,2.967,2.967,0,0,1-.731-1.841A35.352,35.352,0,0,1,4.224,15.237Z",
    transform: "translate(0 3.792)",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonLaddaner);
export default __webpack_public_path__ + "static/media/Ikon_Laddaner.b6b403d67059d4ef44d75b53665ab0fa.svg";
export { ForwardRef as ReactComponent };